module.exports = __webpack_public_path__ + "img/18.c30d104d.svg";